export const closeDrawModePanel = data => {
    return{
        type: 'CLOSE_DRAW_MODE_PANEL',
        payload: data,
    }
}

export const displayDrawModeStartPanel = data => {
    return {
        type   : 'DISPLAY_DRAW_MODE_START_PANEL',
        payload: data,
    }
}

export const drawModeDisplayToggle = data => {
    return {
        type: 'DRAW_MODE_DISPLAY_TOGGLE',
        payload: data,
    }
}

export const startDrawMode = data => {
    return {
        type   : 'START_DRAW_MODE',
        payload: data
    }
}

export const drawModeAnalyze = data => {
    return {
        type: 'DRAW_MODE_ANALYZE',
        payload: data
    }
}

export const drawModePointUpdate = data => {
    return {
        type: 'DRAW_MODE_POINT_UPDATE',
        payload: data,
    }
}

export const drawModeLineStringUpdate = data => {
    return {
        type   : 'DRAW_MODE_LINE_STRING_UPDATE',
        payload: data,
    }
}

export const drawModeReportToggle = data => {
    return {
        type   : 'DRAW_MODE_REPORT_TOGGLE',
        payload: data,
    }
}

export const drawModeSubscribeToggle = data => {
    return {
        type   : 'DRAW_MODE_SUBSCRIBE_TOGGLE',
        payload: data,
    }
}

export const drawModePolygonUpdateFilter = data => {
    return {
        type   : 'DRAW_MODE_POLYGON_UPDATE_FILTER',
        payload: data,
    }
}

export const drawModePolygonRegister = data => {
    return {
        type   : 'DRAW_MODE_POLYGON_REGISTER',
        payload: data,
    }
}

export const drawModePolygonUpdateAnalysisdata = data => {
    return {
        type: 'DRAW_MODE_POLYGON_UPDATE_ANALYSIS_DATA',
        payload: data,
    }
}